import videojs from 'video.js';

type VhsRep = { height: number; enabled: (v?: boolean) => boolean };

function getVhsRepresentations(player: ReturnType<typeof videojs>): VhsRep[] {
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tech = player.tech({ IWillNotUseThisInPlugins: true }) as any;
        return tech?.vhs?.representations?.() ?? [];
    } catch {
        return [];
    }
}

export function buildQualityList(player: ReturnType<typeof videojs>): string[] {
    const reps = getVhsRepresentations(player);
    const heights = Array.from(new Set(reps.map((r) => r.height).filter((h) => h > 0))).sort(
        (a, b) => b - a
    );

    return heights.length > 1 ? ['Auto', ...heights.map((h) => `${h}p`)] : ['Auto'];
}

export function applyQuality(player: ReturnType<typeof videojs>, quality: string): void {
    const reps = getVhsRepresentations(player);

    if (reps.length === 0) {
        return;
    }

    if (quality === 'Auto') {
        reps.forEach((r) => r.enabled(true));
    } else {
        const targetHeight = parseInt(quality);
        reps.forEach((r) => r.enabled(r.height === targetHeight));
    }
}
